<template>
  <button
    @click.stop="handleClick($event)"
    class="rounded flex flex-row items-center font-semibold"
    :class="{
      'bg-secondary': !red,
      'bg-red-600': red,
      'text-lg': !small,
      'text-base': small,
      'py-2 px-4': !inline && !small,
      'py-1 px-2': small,
      'p-1': inline,
      'bg-opacity-0 focus:bg-opacity-25': !raised,
      'hover:bg-opacity-10': !raised && !disabled,
      'text-on-secondary border-2 focus:border-black': raised,
      'hover:border-black': raised && !disabled,
      'text-gray-500 cursor-default': disabled,
      'transition-colors duration-300 ease-in-out': !disabled,
    }"
    :disabled="disabled"
    ref="button"
  >
    <Icon
      v-if="icon && iconLeft"
      :class="{
        'text-xl': small,
        [iconColorClass]: !raised,
        'text-on-secondary': raised,
        'text-gray-600': disabled,
      }"
      >{{ icon }}</Icon
    >
    <span class="mx-1">
      <slot />
    </span>
    <Icon
      v-if="icon && !iconLeft"
      :class="{
        'text-xl': small,
        [iconColorClass]: !raised,
        'text-on-secondary': raised,
        'text-gray-600': disabled,
      }"
      >{{ icon }}</Icon
    >
  </button>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import throttle from 'just-throttle'

defineProps({
  icon: {
    type: String as PropType<string>,
    default: '',
  },
  inline: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  raised: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  disabled: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  focus: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  iconLeft: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  small: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  red: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  iconColorClass: {
    type: String,
    default: 'text-tertiary',
  },
})

const emits = defineEmits(['click'])

const handleClick = throttle(
  (event: MouseEvent) => {
    emits('click', event)
  },
  300,
  {
    leading: true,
    trailing: false,
  },
)
</script>

<style scoped>
button:focus {
  outline: none;
}
</style>
